/*
 * @Author: Yandong Hu
 * @github: https://github.com/Mad-hu
 * @Date: 2022-03-18 09:28:06
 * @LastEditTime: 2022-03-18 10:42:52
 * @LastEditors: Yandong Hu
 * @Description:
 */
const getAccessToken = "/scratch/getAccessToken";

const apis = {
  getAccessToken,
}
export default apis;
